export enum WorkOrderTaskTypeGroup {
  // for work order tasks that can be fully completed at any point
  STEPS_OPTIONAL = 'STEPS_OPTIONAL',
  // for work order tasks that cannot be fully completed until all previous steps have been completed
  STEPS_REQUIRED = 'STEPS_REQUIRED',
  // work order tasks that can only be completed by a system
  SYSTEM_ONLY = 'SYSTEM_ONLY',
}
